module.exports = __webpack_public_path__ + "static/RiskOfRain3-6e1e541c53796c2ae0ad021c1683a4f0.webp";